module.exports = __webpack_public_path__ + "lp/img/vote_good.8dbbe9d3.svg";